import { ViewController, MatchdaypickerView, MatchdaypickerViewDelegate, MatchdayAreaModel, MatchdayPickEvent, Matchday,
         Season, Phase } from "@gaming/srvg-classes-core";
import { PhaseChangeEvent } from "../../Event/PhaseChangeEvent";

// Uses srvg.config, srvg.featuresInstances

export class MatchdaypickerController extends ViewController implements MatchdaypickerViewDelegate {
    matchdayPicker: MatchdaypickerView;
    matchdayAreaModel: MatchdayAreaModel;

    constructor(options) {
        options = options || {};
        options.view = options.matchdayPicker || null;
        super( options );
        this.name = 'matchdaypickerController';

        this.matchdayPicker = options.matchdayPicker || null;

        this.matchdayAreaModel = options.matchdayAreaModel || null;

        this.view.setDelegate(this);

        this.generatedEvents.push( MatchdayPickEvent );
        this.generatedEvents.push( PhaseChangeEvent );
    }

    /**
     * Refreshes view of matchdaypicker
     */
    refreshView() {
        this.matchdayPicker.refresh();
    }

    /**
     * Sets index of homebutton
     */
    updateHomeButton() {
        var homeIndex = this.matchdayPicker.range.findIndex( this.matchdayAreaModel.currentMatchday );
        if( homeIndex !== null ) {
            if( this.matchdayAreaModel.currentPhase.shouldSwitchToNextMatchday() ) {
                homeIndex++;
            }
            this.matchdayPicker.setHomeIndex(homeIndex);
        }
    }

    /**
     * checks if range of matchdaypicker needs to be adjusted
     * Possible reasons:
     *      range is empty
     *      selected season is too old
     *      max season is not too old
     *      next season is available
     */
    isRangeValid(season:Season, matchday:Matchday ) {
        var range = this.matchdayPicker.range.getMatchdays();
        if (!range || !range.length) {
            return false;
        }
        var min = range[0];
        var max = range[range.length - 1];
        if( !min || ! max || !min.getSeason() || !max.getSeason() ) {
            return false;
        }
        if (
            season.id != min.getSeason().id // selected season is too old
            || season.id > max.getSeason().id // max season is not too old
            || ( (season.nextSeason() ? season.nextSeason().id : 0) > max.getSeason().id && matchday.nr >= srvg.config.next_season_available_on_matchday - 1 ) // next season is available
        ) {
            return false;
        }
        return true;
    }

    /**
     * examines timeline data and set the matchday range of the matchday picker
     * warning: this can leave the selectedIndex of the matchday picker in an invalid position, so it should be set immediately afterwards
     */
    updateRange(season:Season, matchday:Matchday) {
        var range = this.matchdayPicker.range;
        range.clear();
        range.push( season.firstMatchday() );
        var lastMatchday = season.lastMatchday();
        range.extendTo( lastMatchday );
        this.matchdayPicker.nextPlaceholders = [ (lastMatchday.nr + 1) % srvg.config.matchdays_per_season, (lastMatchday.nr + 2) % srvg.config.matchdays_per_season ];
        this.matchdayPicker.prevPlaceholders = [ srvg.config.matchdays_per_season, srvg.config.matchdays_per_season-1 ];

        if( season.nextSeason() && !srvg.featuresInstances.getDisableNextSeason() && matchday.nr >= srvg.config.next_season_available_on_matchday ) {
            this.extendRangeToSeason( season );
        }
    }

    /**
     * Extends range of matchday picker to given season
     */
    extendRangeToSeason(season:Season) {
        var lastMatchday = season.lastMatchday();

        // if season is current season and current matchday >= srvg.config.next_season_available_on_matchday
        var currentSeason = this.matchdayAreaModel.currentMatchday.getSeason();
        // FIXME is this actually needed? Because there seems to be a bug when extending the season on matchday 1 or 2 of a new season
        if( season.nr == currentSeason.nr &&
            this.matchdayAreaModel.currentMatchday.nr >= srvg.config.next_season_available_on_matchday &&
            season.nextSeason() &&
            !srvg.featuresInstances.getDisableNextSeason()
        ) {
            lastMatchday = season.nextSeason().getMatchday(srvg.config.number_of_matchdays_available_of_next_season);
        }
        this.matchdayPicker.range.extendTo( lastMatchday );
        // FIXME there shouldn't be a discrepancy, but there is on day 1 or 2
        lastMatchday = this.matchdayPicker.range.last();
        this.matchdayPicker.nextPlaceholders = [ (lastMatchday.nr + 1) % srvg.config.matchdays_per_season, (lastMatchday.nr + 2) % srvg.config.matchdays_per_season ];
        this.matchdayPicker.prevPlaceholders = [ srvg.config.matchdays_per_season, srvg.config.matchdays_per_season-1 ];
    }

    /**
     * Checks if position of matchdaypicker needs to be adjusted
     */
    isCurrentPositionValid(eventSeason:Season,eventMatchday:Matchday,eventPhase:Phase) {
        var selectedMatchday = this.matchdayAreaModel.selectedMatchday;
        if (!selectedMatchday) {
            // matchday picker not initialized
            return false;
        }
        if (eventSeason.nr > selectedMatchday.getSeason().nr) {
            // next season has arrived
            return false;
        }
        if (eventSeason.nr == selectedMatchday.getSeason().nr && eventMatchday.nr > selectedMatchday.nr) {
            // next matchday in same season has arrived
            return false;
        }
        if (
            eventSeason.nr === selectedMatchday.getSeason().nr
            && eventMatchday.nr === selectedMatchday.nr
            && eventPhase.shouldSwitchToNextMatchday()
        ) {
            // a phase on the same matchday has arrived on which the matchday should be changed
            return false;
        }
        return true;
    }

    // ************************** Event handlers **************************

    /**
     * Called when the matchdaypicker sends a matchdayPick event
     */
    handleMatchdayPickEvent(event:MatchdayPickEvent, provider) {
        this.triggerEvent( event )
    }

    /**
     * Event handler for timeout events (sent by inactivity controller)
     */
    handleTimeoutEvent(event, provider) {
        this.matchdayPicker.deactivate();
    }
}